import { useState, useEffect, useRef } from 'react';
import '../../styles/global.css';
import { isCPFValid, isCNPJValid } from '../../utils/cadastro';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { InputMask } from "primereact/inputmask";
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { MenuItem } from 'primereact/menuitem';
import { Steps } from 'primereact/steps';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import API from '../../api/API';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import * as messages from '../../utils/messages'
import { ProgressSpinner } from 'primereact/progressspinner';
import { Avatar } from 'primereact/avatar';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import BadgeIcon from '@mui/icons-material/Badge';
import DocumentFileUpload from '../components/DocumentFileUpload';

import { pdfjs } from 'react-pdf';
import { newPessoa, PessoaType } from '../../db/Orm';
import Correios from '../../api/Correios';
import Brasil from '../../api/Brasil';
import InputCpfCnpj from '../components/InputCpfCnpj';
import { PiIdentificationCard, PiIdentificationCardBold } from 'react-icons/pi';
import { Checkbox } from 'primereact/checkbox';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
    state: boolean
    function: Function
    pessoa: PessoaType
    setPessoa: Function
    activeIndex: number
    setActiveIndex: Function
    pessoas: Array<PessoaType>
    edit: boolean
}

export const tipoTemplate = (pessoa: PessoaType) => (<>{pessoa.cpf_cnpj.length > 14 ? <Avatar icon="pi pi-building" style={{ backgroundColor: '#9c27b0', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar> : <Avatar icon="pi pi-user" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />}</>)

export function CadastroPessoa(props: Props) {
    // console.log('Cadastro Pessoa Dialog Props:', props)
    // const [user, setUser] = useState<PessoaType>(props.pessoa?props.pessoa:newPessoa)
    const tipos = ['Pessoa Física', 'Pessoa Jurídica']
    const [tipo, setTipo] = useState<string>(props.pessoa.cpf_cnpj.length > 14 ? tipos[1] : tipos[0])
    const labelsNome = ['Nome completo', 'Razão social']
    const [labelRazao, setLabelRazao] = useState<string>(labelsNome[tipos.indexOf(tipo)])
    const labelsDocsCPF = ['CPF', 'Cartão CNPJ']
    const [labelDocCPF, setLabelDocCPF] = useState<string>(labelsDocsCPF[tipos.indexOf(tipo)])
    const labelsDocsRG = ['RG', 'Contrato Social']
    const [labelDocRG, setLabelDocRG] = useState<string>(labelsDocsRG[tipos.indexOf(tipo)])
    const labelsDocsComp = ['Comprovante de Residência', 'Comprovante de Endereço']
    const [labelDocComp, setLabelDocComp] = useState<string>(labelsDocsComp[tipos.indexOf(tipo)])
    const labelsDocumentacao1 = ['CPF', 'CNPJ']
    const [labelCNPJ, setLabelCNPJ] = useState<string>(labelsDocumentacao1[tipos.indexOf(tipo)])
    const labelsDocumentacao2 = ['RG', 'Inscrição estadual']
    const [labelInsc, setLabelInsc] = useState<string>(labelsDocumentacao2[tipos.indexOf(tipo)])
    const mascarasCadastro = ['999.999.999-99', '99.999.999/9999-99']
    const [maskCNPJ, setMaskCNPJ] = useState<string>(mascarasCadastro[tipos.indexOf(tipo)])
    const holderRazoes = ['Digite o nome completo', 'Digite a razão social']
    const [holderRazao, setHolderRazao] = useState<string>(holderRazoes[tipos.indexOf(tipo)])
    const relacionamentos = ['Cônjuge', 'Responsável legal']
    const [labelRelacionamento, setLabelRelacionamento] = useState<string>(relacionamentos[tipos.indexOf(tipo)])
    const [invalidCPFCNPJMessage, setinvalidCPFCNPJMessage] = useState<string | null>(null)
    const [loadingAddress, setLoadingAddress] = useState(false)
    const inputMasksTelCel = ['(99) 9999-9999', '(99) 9 9999-9999']
    const [inputMaskTelCel, setInputMaskTelCel] = useState<string>(inputMasksTelCel[1]);
    const [docCpfCnpj, setDocCpfCnpj] = useState<any>(null);
    const [docRg, setDocRg] = useState<any>(null);
    const [docRes, setDocRes] = useState<any>(null);
    const [docPassaporte, setDocPassaporte] = useState<any>(null);

    useEffect(() => {
        const t = props.pessoa.cpf_cnpj.length > 14 ? tipos[1] : tipos[0]
        setTipo(t)
        setLabelRazao(labelsNome[tipos.indexOf(t)])
        setLabelDocCPF(labelsDocsCPF[tipos.indexOf(t)])
        setLabelDocRG(labelsDocsRG[tipos.indexOf(t)])
        setLabelDocComp(labelsDocsComp[tipos.indexOf(t)])
        setLabelCNPJ(labelsDocumentacao1[tipos.indexOf(t)])
        setLabelInsc(labelsDocumentacao2[tipos.indexOf(t)])
        setMaskCNPJ(mascarasCadastro[tipos.indexOf(t)])
        setHolderRazao(holderRazoes[tipos.indexOf(t)])
        setLabelRelacionamento(relacionamentos[tipos.indexOf(t)])
        setInputMaskTelCel(props.pessoa.celular.length === 14 ? inputMasksTelCel[0] : inputMasksTelCel[1])
    }, [props.state])

    const validateCPFCNPJ = async (value?: string) => {
        if (!value) value = props.pessoa.cpf_cnpj
        if (value.length > 0 && value.indexOf('_') < 0) {
            if (tipo === tipos[0]) {
                if (isCPFValid(value)) {
                    setErrorCPFCNPJ('')
                    if (props.pessoa.id){
                        return true
                    }
                    if (await API.cpfExists(value))
                        setErrorCPFCNPJ('* CPF já cadastrado')
                    else
                        return true
                    // const p = await getPessoaExploded(value, null, () => { })
                    // if (p !== null)
                    // setErrorCPFCNPJ('CPF já cadastrado!')
                }
                else
                    setErrorCPFCNPJ('* CPF inválido')
            }
            else if (tipo === tipos[1]) {
                if (isCNPJValid(value)) {
                    setErrorCPFCNPJ('')

                    if (props.pessoa.id){
                        return true
                    }
                    if (await API.cpfExists(value))
                        setErrorCPFCNPJ('* CNPJ já cadastrado')
                    else {
                        try {
                            const cnpjData = await Brasil.cnpj(value);                            
                            if (cnpjData) {
                                props.setPessoa((prevPessoa: PessoaType) => ({
                                    ...prevPessoa,
                                    nome_razao: cnpjData.nome_razao,
                                    email: cnpjData.email,
                                    celular: cnpjData.celular,
                                    cep: cnpjData.cep,
                                    endereco: cnpjData.endereco,
                                    numero: cnpjData.numero,
                                    bairro: cnpjData.bairro,
                                    cidade: cnpjData.cidade,
                                    uf: cnpjData.uf,
                                }));
                            }
                            return true
                        } catch (error) {
                            setErrorCPFCNPJ('CNPJ inválido')
                            return false
                        }
                    }
                }
                else {
                    setErrorCPFCNPJ('CNPJ inválido')
                }
            }
        } else {
            setErrorCPFCNPJ('')
        }
        return false
    }

    const updateTelCelMask = (event: any) => {
        const celNumber = props.pessoa.celular.replaceAll(/\D+/g, '');
        if (celNumber.length !== 10) {
            setInputMaskTelCel(inputMasksTelCel[1]);
        } else if (event.originalEvent.type === 'keypress') {
            setInputMaskTelCel(inputMasksTelCel[1]);
        }
        if (event.originalEvent.type === 'blur'){
            if (celNumber.length === 10) {
                setInputMaskTelCel(inputMasksTelCel[0]);
                setTimeout(()=>{
                    props.setPessoa && props.setPessoa({
                        ...props.pessoa,
                        celular: `(${celNumber.substring(0,2)}) ${celNumber.substring(2,6)}-${celNumber.substring(6,10)}`
                }, 50)})
            }
        }
    }

    const changeField = async (event: any) => {
        var { value, name } = event.target;
        // ✅ Verifica se o valor é uma string antes de converter
        if (typeof value === 'string') {
            value = value.toUpperCase();
        }
        props.setPessoa && props.setPessoa({
            ...props.pessoa,
            [name]: value
        })
        if (name === 'nome_razao') {
            setErrorNome('')
        } else if (name === 'cpf_cnpj') {
            setErrorCPFCNPJ('')
            await validateCPFCNPJ(value)
        } else if (name === 'logradouro') {
            setErrorLogradouro('')
        } else if (name === 'cidade') {
            setErrorCidade('')
        } else if (name === 'uf') {
            setErrorUF('')
        } else if (name === 'cep') {
            setErrorCEP('')
            if (value.indexOf('_') < 0) {
                const cep = value.replaceAll('.', '').replaceAll('-', '')
                const addr = await Correios.consultCEP(cep)
                if (addr.erro)
                    props.setPessoa({
                        ...props.pessoa,
                        cep: value,
                        endereco: '',
                        bairro: '',
                        cidade: '',
                        uf: ''
                    })
                else {
                    setErrorCEP('')
                    setErrorLogradouro('')
                    setErrorCidade('')
                    setErrorUF('')
                    props.setPessoa({
                        ...props.pessoa,
                        cep: addr.cep,
                        endereco: addr.logradouro.toUpperCase(),
                        bairro: addr.bairro.toUpperCase(),
                        cidade: addr.localidade.toUpperCase(),
                        uf: addr.uf
                    })
                }
                setLoadingAddress(false)
            } else {
                props.setPessoa({
                    ...props.pessoa,
                    cep: value,
                    endereco: '',
                    bairro: '',
                    cidade: '',
                    uf: ''
                })
                setLoadingAddress(true)

            }
        } else if (name === 'celular') {
            updateTelCelMask(event)
            setErrorCelular('')
        } else if (name === 'email') {
            setErrorEmail('')
        }
    }
    const setCpfCnpjValue = (value: string) => {
        props.setPessoa && props.setPessoa({
            ...props.pessoa,
            cpf_cnpj: value
        })
        validateCPFCNPJ(value)
    }
    const onCpfCnpjModeChange = (mode: 'cpf'|'cnpj') => {
        handleTipo({ value: mode === 'cpf' ? tipos[0] : tipos[1] });
    }


    const [waiting, setWaiting] = useState(false)
    const fetchData = async () => {
        setWaiting(true)
        try {
            const formData = new FormData();
            formData.append("nome_razao", props.pessoa.nome_razao)
            formData.append("cpf_cnpj", props.pessoa.cpf_cnpj)
            formData.append("rg_insc", props.pessoa.rg_insc)
            // formData.append("conjuge", '-')
            formData.append("cep", props.pessoa.cep)
            formData.append("endereco", props.pessoa.endereco)
            formData.append("numero", props.pessoa.numero)
            formData.append("bairro", props.pessoa.bairro)
            formData.append("cidade", props.pessoa.cidade)
            formData.append("uf", props.pessoa.uf)
            formData.append("celular", props.pessoa.celular)
            formData.append("email", props.pessoa.email)
            formData.append("receber_notificacoes", props.pessoa.receber_notificacoes ? 'true' : 'false')

            docCpfCnpj&&formData.append("doc_cpf_cartao_cnpj", docCpfCnpj)
            docRg&&formData.append("doc_rg", docRg)
            docRes&&formData.append("doc_res", docRes)

            if (docPassaporte) formData.append("doc_passaporte", docPassaporte)
            const authHeaders = API.getAuthHeaders()
            const response = await fetch(API.url + (props.pessoa.id?'pessoas/'+props.pessoa.id+'/':'autoregistro/'),
                {
                    method: props.pessoa.id ? 'PUT' : 'POST',
                    body: formData,
                    headers: props.pessoa.id ? {...authHeaders.headers} : {}
                });
            console.log('Response', response)
            if (response.status === 201) {//CADASTRO OK
                const data = await response.json()
                var id = data.id && data.id || ''
                props.setActiveIndex(0)
                savedPessoa(id)
                props.setPessoa(newPessoa())
            } else if (response.status === 200) { //ATUALIZACAO OK
                const data = await response.json();
                var id: any = ''
                if (data.url)
                    id = data.url?.replace(API.url + 'ADAB-farms/', '').replace("/", "");
                else
                    id = data.id && data.id
                setWaiting(false)
                updatedPessoa(id)
                const oldPessoaIndex = props.pessoas.findIndex((p) => p.id === props.pessoa.id);
                if (oldPessoaIndex !== -1) {
                    props.pessoas[oldPessoaIndex] = data;
                }
            } else if (response.status === 400) {
                const data = await response.json();
                console.log('Data', data)
                messages.errorMessage(toast.current, response.statusText + ': ' + JSON.stringify(data))
            } else {
                const data = await response.json();
                console.log('Data', data)
                messages.errorMessage(toast.current, response.statusText + ': ' + data.detail)
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setWaiting(false)
        }
    }
    const onChangeReceberEmail = (e: any) => {
        props.setPessoa && props.setPessoa({
            ...props.pessoa,
            receber_notificacoes: e.checked
        })
    }

    function cadastrar(event: React.FormEvent) {
        event.preventDefault();
        if (docCpfCnpj === null || docRg === null || docRes === null)
            fetchData()//toast.current && toast.current.show({ severity: 'error', summary: 'Documentação', detail: 'Documentos incompletos!' });
        else {
            fetchData();
        }
    }

    const handleTipo = async (event: any) => {
        setTipo(event.value)
        var t = event.value === tipos[0] ? 0 : 1
        setMaskCNPJ(mascarasCadastro[t])
        setHolderRazao(holderRazoes[t])
        setLabelRazao(labelsNome[t])
        setLabelCNPJ(labelsDocumentacao1[t])
        setLabelInsc(labelsDocumentacao2[t])
        setLabelRelacionamento(relacionamentos[t])
        setLabelDocCPF(labelsDocsCPF[t])
        setLabelDocRG(labelsDocsRG[t])
        setLabelDocComp(labelsDocsComp[t])
    }
    useEffect(() => {
        validateCPFCNPJ(props.pessoa.cpf_cnpj)
    }, [tipo])

    const toast = useRef<Toast | null>(null);
    const toastBC = useRef<Toast | null>(null);
    // const [activeIndex, setActiveIndex] = useState(0)
    const [errorNome, setErrorNome] = useState('')
    const [errorCPFCNPJ, setErrorCPFCNPJ] = useState('')
    const [errorCEP, setErrorCEP] = useState('')
    const [errorLogradouro, setErrorLogradouro] = useState('')
    const [errorCidade, setErrorCidade] = useState('')
    const [errorUF, setErrorUF] = useState('')
    const [errorCelular, setErrorCelular] = useState('')
    const [errorEmail, setErrorEmail] = useState('')
    const verifyData = async (event: any) => {
        if (props.pessoa.id){
            props.setActiveIndex(event.index)
            return
        }
        if (event.index > props.activeIndex) {
            if (props.activeIndex === 0) {
                if (props.pessoa.nome_razao.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'Nome não informado!' });
                    setErrorNome('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[0] && props.pessoa.nome_razao.indexOf(' ') < 0) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'Nome incompleto!' });
                    setErrorNome('* Nome incompleto')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[0] && props.pessoa.cpf_cnpj.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CPF não informado!' });
                    setErrorCPFCNPJ('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[1] && props.pessoa.cpf_cnpj.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CNPJ não informado!' });
                    setErrorCPFCNPJ('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[0] && props.pessoa.cpf_cnpj.indexOf('_') > -1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CPF incompleto!' });
                    setErrorCPFCNPJ('* CPF incompleto')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[1] && props.pessoa.cpf_cnpj.indexOf('_') > -1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CNPJ incompleto!' });
                    setErrorCPFCNPJ('* CNPJ incompleto')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[0] && !isCPFValid(props.pessoa.cpf_cnpj)) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CPF inválido!' });
                    setErrorCPFCNPJ('* CPF inválido')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[1] && !isCNPJValid(props.pessoa.cpf_cnpj)) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CNPJ inválido!' });
                    setErrorCPFCNPJ('* CNPJ inválido')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[0] && props.edit && await API.cpfExists(props.pessoa.cpf_cnpj)) {
                    console.log('Edit', props.edit)
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CPF já cadastrado!' });
                    setErrorCPFCNPJ('* CPF já cadastrado')
                    props.setActiveIndex(props.activeIndex)
                } else if (tipo === tipos[1] && props.edit && await API.cpfExists(props.pessoa.cpf_cnpj)) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Dados pessoais', detail: 'CNPJ já cadastrado!' });
                    setErrorCPFCNPJ('* CNPJ já cadastrado')
                    props.setActiveIndex(props.activeIndex)
                } else {
                    setErrorNome('')
                    setErrorCPFCNPJ('')
                    // toast.current.show({ severity: 'success', summary: 'Dados pessoais', detail: 'Informações válidas!' });
                    props.setActiveIndex(event.index)
                }
            } else if (props.activeIndex === 1) {
                if (props.pessoa.cep.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Endereço', detail: 'CEP não informado!' });
                    setErrorCEP('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else if (props.pessoa.cep.indexOf('_') > -1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Endereço', detail: 'CEP incompleto!' });
                    setErrorCEP('* CEP incompleto')
                    props.setActiveIndex(props.activeIndex)
                } else if (props.pessoa.cidade.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Endereço', detail: 'Cidade não informada!' });
                    setErrorCidade('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else if (props.pessoa.uf.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Endereço', detail: 'UF não informada!' });
                    setErrorUF('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else {
                    // toast.current.show({ severity: 'success', summary: 'Dados pessoais', detail: 'Informações válidas!' });
                    props.setActiveIndex(event.index)
                }

            } else if (props.activeIndex === 2) {
                if (props.pessoa.celular.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Contato', detail: 'Celular não informado!' });
                    setErrorCelular('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)

                } else if (props.pessoa.celular.indexOf('_') > -1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Contato', detail: 'Celular não informado!' });
                    setErrorCelular('* Celular incompleto')
                    props.setActiveIndex(props.activeIndex)

                } else if (props.pessoa.email.length < 1) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Contato', detail: 'Email não informado!' });
                    setErrorEmail('* Campo obrigatório')
                    props.setActiveIndex(props.activeIndex)
                } else if (props.pessoa.email.indexOf('@') < 0 || props.pessoa.email.indexOf('.') < 0) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Contato', detail: 'Email não informado!' });
                    setErrorEmail('* Email inválido')
                    props.setActiveIndex(props.activeIndex)
                } else {
                    // toast.current.show({ severity: 'success', summary: 'Dados pessoais', detail: 'Informações válidas!' });
                    props.setActiveIndex(event.index)
                }

            } else if (props.activeIndex === 3) {
                if (tipo === tipos[1] && props.pessoa.conj_resp === null) {
                    toast.current && toast.current.show({ severity: 'error', summary: 'Relacionamento', detail: 'Responsável legal não informado!' });
                    //     setActiveIndex(activeIndex)
                    // } else {
                    // toast.current.show({ severity: 'success', summary: 'Dados pessoais', detail: 'Informações válidas!' });
                    props.setActiveIndex(event.index)
                }
            }
        } else props.setActiveIndex(event.index)
    }
    const items: MenuItem[] = [
        {
            label: 'Dados pessoais',
            command: (event) => verifyData(event),
        },
        {
            label: 'Endereço',
            command: verifyData
        },
        {
            label: 'Contato',
            command: verifyData
        },
        {
            label: 'Documentos',
            command: verifyData
        }
    ];

    const accept = () => {
        props.setActiveIndex(0)
    }

    const reject = () => {
        props.function(false)
    }

    const savedPessoa = (id?: any) => {
        confirmDialog({
            message: (
                <div>
                    ▶ Pessoa {id ? (' de id ' + id) : ''} cadastrada com sucesso!
                    {/* <br />Será enviado um e-mail e WhatsApp confirmando o cadastro no endereço e número informado. */}
                    <br />
                    <br /><b>ATENÇÃO:</b>
                    <br />
                    <br />O usuário e senha serão gerados após aprovação deste cadastro!
                    <br />Será enviado um e-mail e WhatsApp com o acesso após aprovação.
                    <br />Favor aguardar a aprovação!
                    <br />
                    <br />Deseja adicionar outro usuário?
                </div>
            ),
            header: '✅ Cadastro de Usuário',
            accept: accept,
            reject: reject
        });
    };

    const updatedPessoa = (id: any) => {
        messages.message(toastBC.current, 'Usuário de id ' + id + ' atualizado com sucesso!')
    };

    return (
        <Dialog className='CadastroUser' header="CADASTRO DE PESSOA" visible={props.state} style={{ width: 'max(50dvw, min(750px, 100dvw))' }} onHide={() => props.function(false)}>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Toast ref={toastBC} position="center" onRemove={() => toastBC.current && messages.clear(toastBC.current)} />
            <Steps model={items} activeIndex={props.activeIndex} onSelect={(e: any) => props.setActiveIndex(e.index)} readOnly={false} />
            <br />
            {props.activeIndex === 0 && <div>
                <Divider align='left'>
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-briefcase"></i>
                        <b> Tipo</b>
                    </div>
                </Divider>

                <div className="card flex justify-content-center">
                    <SelectButton value={tipo} onChange={handleTipo} options={tipos} disabled={!props.edit} />
                </div>

                <Divider align='left'>
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-id-card"></i>
                        <b> Dados de identificação</b>
                    </div>
                </Divider>
                <br />
                <div style={{ display: 'flex', width: '100%' }}>
                    <div className="flex flex-column gap-2" style={{ width: '100%' }}>
                        <div className="p-inputgroup flex-1">
                            <InputCpfCnpj value={props.pessoa.cpf_cnpj} setValue={setCpfCnpjValue} includeButton={false}
                            labelIcon={<i className='pi pi-id-card' />} onModeChange={onCpfCnpjModeChange}
                            externalMode={tipo===tipos[0]?'cpf':'cnpj'} id="ssn_inputa" floatLabel={labelCNPJ}
                             />
                        </div>
                        <small style={{ color: 'red' }}>{errorCPFCNPJ}    </small>
                    </div>
                    <span>&nbsp;</span>
                    <div className="flex flex-column gap-2" style={{ width: '100%' }}>
                        <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><i className="pi pi-id-card"></i></span>
                            <span className="p-float-label">
                                <InputText id="rg_insc_input" name='rg_insc'
                                    keyfilter="int"
                                    value={props.pessoa.rg_insc}
                                    onChange={changeField}
                                    disabled={!props.edit}
                                />
                                <label htmlFor="rg_insc_input">{labelInsc}</label>
                            </span>
                        </div>
                        {/* <small id="username-help">Campo opcional</small> */}
                    </div>
                </div>
                <Divider align='left'>
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-user"></i>
                        <b> {labelRazao}</b>
                    </div>
                </Divider>
                <br />
                <div className="flex flex-column gap-2">
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><i className="pi pi-user"></i></span>
                        <span className="p-float-label">
                            <InputText id="username" name='nome_razao' value={props.pessoa.nome_razao} onChange={changeField} disabled={!props.edit} />
                            <label htmlFor="username">{holderRazao}</label>
                        </span>
                    </div>
                    <small style={{ color: 'red' }}>{errorNome}</small>
                </div>
            </div>}

            {props.activeIndex === 1 &&
                <div><Divider align='left'>
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-map-marker"></i>
                        <b> Endereço</b>
                    </div>
                </Divider>
                    <br />
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div className="flex flex-column gap-2" style={{ width: '30%' }}>
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-map-marker"></i></span>
                                <span className="p-float-label">
                                    <InputMask id="ssn_input" name='cep'
                                        value={props.pessoa.cep} onChange={changeField}
                                        mask="99999-999"
                                        disabled={!props.edit}
                                    />
                                    <label htmlFor="ssn_input">CEP</label>
                                </span>
                            </div>
                            <small style={{ color: 'red' }}>{errorCEP}</small>
                        </div>
                        <span>&nbsp;</span>
                        <div className="flex flex-column gap-2" style={{ width: '50%' }}>
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-compass"></i></span>
                                <span className="p-float-label p-input-icon-right">
                                    {loadingAddress && <i className="pi pi-spin pi-spinner" />}
                                    <InputText id="ssn_input" name='endereco' value={props.pessoa.endereco} onChange={changeField} disabled={!props.edit} />
                                    <label htmlFor="ssn_input">Logradouro</label>
                                </span>
                            </div>
                            <small style={{ color: 'red' }}>{errorLogradouro}</small>
                        </div>
                        <span>&nbsp;</span>
                        <div className="flex flex-column gap-2" style={{ width: '20%' }}>
                            <div className="p-inputgroup flex-1">
                                <span className="p-inputgroup-addon">00</span>
                                <span className="p-float-label">
                                    <InputNumber id="ssn_input" name='numero' value={Number(props.pessoa.numero)} onChange={(e) => changeField({ target: { name: 'numero', value: e.value } })} disabled={!props.edit} />
                                    <label htmlFor="ssn_input">Número</label>
                                </span>
                            </div>
                        </div>
                    </div>

                    <br />
                    <br />

                    <div style={{ display: 'flex', width: '100%' }}>
                        <div className="flex flex-column gap-2" style={{ width: '40%' }}>
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-sitemap"></i></span>
                                <span className="p-float-label p-input-icon-right">
                                    {loadingAddress && <i className="pi pi-spin pi-spinner" />}
                                    <InputText id="ssn_input" name='bairro' value={props.pessoa.bairro} onChange={changeField} disabled={!props.edit} />
                                    <label htmlFor="ssn_input">Bairro</label>
                                </span>
                            </div>
                        </div>
                        <span>&nbsp;</span>
                        <div className="flex flex-column gap-2" style={{ width: '40%' }}>
                            <div className="flex flex-column p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-map"></i></span>
                                <span className="p-float-label p-input-icon-right">
                                    {loadingAddress && <i className="pi pi-spin pi-spinner" />}
                                    <InputText id="ssn_input" name='cidade' value={props.pessoa.cidade} onChange={changeField} disabled={!props.edit} />
                                    <label htmlFor="ssn_input">Cidade</label>
                                </span>
                            </div>
                            <small style={{ color: 'red' }}>{errorCidade}</small>
                        </div>
                        <span>&nbsp;</span>
                        <div className="flex flex-column gap-2" style={{ width: '20%' }}>
                            <div className="p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className='pi pi-flag'></i></span>
                                <span className="p-float-label p-input-icon-right">
                                    {loadingAddress && <i className="pi pi-spin pi-spinner" />}
                                    <InputText id="ssn_input" name='uf' value={props.pessoa.uf} onChange={changeField} disabled={!props.edit} />
                                    <label htmlFor="ssn_input">UF</label>
                                </span>
                            </div>
                            <small style={{ color: 'red' }}>{errorUF}</small>
                        </div>

                    </div>
                </div>
            }
            {props.activeIndex === 2 &&
                <div>
                    <Divider align='left'>
                        <div className="inline-flex align-items-center">
                            <i className="pi pi-envelope"></i>
                            <b> Contato</b>
                        </div>
                    </Divider>
                    <br />
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div className="flex flex-column gap-2" style={{ width: '30%' }}>
                            <div className="p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-phone"></i></span>
                                <span className="p-float-label">
                                    <InputMask id="ssn_inputa" name='celular'
                                        value={props.pessoa.celular}
                                        mask={inputMaskTelCel}
                                        onChange={changeField}
                                        disabled={!props.edit}
                                        autoClear={false}
                                    />
                                    <label htmlFor="ssn_inputa">Celular</label>
                                </span>
                            </div>
                            <small style={{ color: 'red' }}>{errorCelular}</small>
                        </div>
                        <span>&nbsp;</span>
                        <div className="flex flex-column gap-2" style={{ width: '70%' }}>
                            <div className="p-inputgroup flex-1">
                                <span className="p-inputgroup-addon"><i className="pi pi-at"></i></span>
                                <span className="p-float-label">
                                    <InputText id="rg_insc_input" name='email'
                                        keyfilter="email"
                                        value={props.pessoa.email}
                                        onChange={changeField}
                                        disabled={!props.edit}
                                    />
                                    <label htmlFor="rg_insc_input">E-mail</label>
                                </span>
                            </div>
                            <small style={{ color: 'red' }}>{errorEmail}</small>
                        </div>
                    </div>
                    <div style={{marginTop: '1rem'}}>
                        <Checkbox checked={props.pessoa.receber_notificacoes||false} onChange={onChangeReceberEmail} disabled={!props.edit}/>
                        <small> Desejo receber e-mails sobre o andamento do meu cadastro e outras comunicações.</small>
                    </div>
                    <br />
                    {/* <div>
                        <Divider align='left'>
                            <div className="inline-flex align-items-center">
                                <i className="pi pi-users"></i>
                                <b> {labelRelacionamento}</b>
                            </div>
                        </Divider>
                        <Dropdown
                            name='conj_resp'
                            value={props.pessoa.conj_resp}
                            onChange={(e) => changeField({ target: { name: 'conj_resp', value: e.value } })}
                            options={props.pessoas}
                            optionLabel="name"
                            placeholder="Selecione uma pessoa"
                            filter
                            className="w-full md:w-14rem"
                            disabled={!props.edit}
                        />
                    </div> */}
                </div >
            }
            {props.activeIndex === 3 &&
                <div>
                    <DocumentFileUpload
                        label={labelDocCPF}
                        icon={<BadgeIcon />}
                        initialFile={props.pessoa.doc_cpf_cartao_cnpj}
                        onFileSelect={setDocCpfCnpj}
                        editMode={props.edit}
                    />
                    <DocumentFileUpload
                        label={labelDocRG}
                        icon={<BadgeIcon />}
                        initialFile={props.pessoa.doc_rg}
                        onFileSelect={setDocRg}
                        editMode={props.edit}
                    />
                    <DocumentFileUpload
                        label={labelDocComp}
                        icon={<HomeWorkIcon />}
                        initialFile={props.pessoa.doc_res}
                        onFileSelect={setDocRes}
                        editMode={props.edit}
                    />
                    {tipo === tipos[0] && (
                        <DocumentFileUpload
                            label="Passaporte (Obrigatório apenas para estrangeiros)"
                            icon={<AssignmentIndIcon />}
                            initialFile={props.pessoa.doc_passaporte}
                            onFileSelect={setDocPassaporte}
                            editMode={props.edit}
                        />
                    )}
                </div>
            }
            <br />
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'left', width: '50%' }}>
                    {props.activeIndex > 0 &&
                        <Button label='ANTERIOR' icon='pi pi-arrow-left' rounded onClick={() => verifyData({ index: props.activeIndex - 1 })} />
                    }
                </div>
                <div style={{ display: 'flex', justifyContent: 'right', width: '50%' }}>
                    {props.activeIndex < 3 ?
                        <Button label='PRÓXIMO' icon='pi pi-arrow-right' iconPos='right' rounded onClick={() => verifyData({ index: props.activeIndex + 1 })} />
                        :
                        <Button label={waiting ? '' : (props.pessoa.id ? 'ATUALIZAR' : 'CADASTRAR')} icon={waiting ? '' : 'pi pi-send'} iconPos='right' severity="success" rounded onClick={cadastrar} disabled={!props.edit || waiting} >{waiting && <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />}</Button>
                    }
                </div>
            </div>
            {/* </div> */}
        </Dialog>
    );
}

export default CadastroPessoa;
